// extracted by mini-css-extract-plugin
export default {"appointmentWrapper":"createActivityForm_appointmentWrapper__90Vs1","select":"createActivityForm_select__5d3N-","saveButton":"createActivityForm_saveButton__iDP8b"};